export default function convertPrice(price) {
    return parseFloat(price.match(/[0-9]\d*\.?(\d{1,2})?/));
}
